module.exports = __webpack_public_path__ + "img/idea-icon.a67af462.svg";